import { cx } from "@emotion/css";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { PropsWithChildren } from "react";

type SelectableChipProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function SelectableChip({ children, checked, onChange }: PropsWithChildren<SelectableChipProps>) {
  return (
    <button
      type="button"
      className={cx("badge", "pill", "text-primary", "border-0", "d-flex", "gap-1", "fs-6", "p-2", {
        "bg-primary": checked,
        "bg-secondary": !checked,
        "text-white": checked,
        "text-primary": !checked,
      })}
      onClick={() => onChange(!checked)}
    >
      {children}
      {checked && <FontAwesomeIcon icon={faCheck} />}
    </button>
  );
}
